<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div class="skeleton-preloader__inner-cnt">
  @if (loadingLabel) {
    <span class="profile:sr-only">{{ loadingLabel }}</span>
  }
  <div class="profile:content" aria-hidden="true">
    @if (loaderMode === LoaderModes.PERSONAL_DATA) {
      <div>
        <div class="skeleton-preloader__item skeleton-preloader__item--large skeleton-preloader__item--invisible-on-mobile"></div>
      </div>
    }
    @if (loaderMode === LoaderModes.PERSONAL_DATA) {
      <div>
        <div class="skeleton-preloader__item skeleton-preloader__item--large"></div>
        <div class="skeleton-preloader__item skeleton-preloader__item--small"></div>
      </div>
    }
    @if (loaderMode === LoaderModes.ORDERS) {
      <div>
        <div class="skeleton-preloader__item skeleton-preloader__item--small"></div>
        <div class="skeleton-preloader__item skeleton-preloader__item--large"></div>
      </div>
    }
  </div>
</div>
